module.exports = __webpack_public_path__ + "static/fonts/Mont-Light.b2eac4c.ttf";